export default __webpack_public_path__ + "static/media/5.5119a018.webp";